import Constants from '@usas/ui-web/utils/Constants';
import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

import getClubHistoryData from './GetClubHistoryData';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE,
  usasClubId: Constants.DEFAULT_ID
};

const ClubHistoryData = {
  INITIAL_STATE, getClubHistoryData
};

export default ClubHistoryData;